<template>
    <div class="slider-area" v-if="(this.sharedState.selectedLayer === 1 || this.sharedState.selectedLayer === 2) && this.config.sliderVisibility">
      <div class="slider-inner">
        <label v-if="this.isNotEdge">
           &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        </label>

          <input class="slider" type="range" v-bind:step="this.config.step" v-bind:min="this.config.start" v-bind:max="this.config.end"
            v-model="localYear"
            @mouseup="onChange($event)"
            @touchend="onChange($event)"
            @keyup="onChange($event)"
          >
      </div>
      <ul class="year-label">
        <li v-for="i in labelList" :key="i">
          <img :src="require(`../../assets/img/y_${i}.png`)">
        </li>
        <!-- <li><img src="../../assets/img/y_2020.png"></li>
        <li><img src="../../assets/img/y_2025.png"></li>
        <li><img src="../../assets/img/y_2030.png"></li>
        <li><img src="../../assets/img/y_2035.png"></li>
        <li><img src="../../assets/img/y_2040.png"></li> -->
      </ul>
    </div>
</template>

<script>
export default {
    name: 'year-control',
    data () {
      return{
        localYear: this.$store.state.year
      }
    },
    computed: {
      sharedState () {
        return this.$store.state
      },
      config() {
        return this.$store.state.config_from_api
      },
      year: {
        get () {
          return this.$store.state.year
        },
        set (value) {
          this.$store.commit('setYear', value)
        }
      },
      labelList() {
        const numLabel = (this.config.end - this.config.start) / 5
        let labelList = []
        labelList.push(Number(this.config.start))
        for (let i=1; i <= numLabel; i++) {
          labelList.push(Number(this.config.start) + 5*i)
        }
        return labelList
      },
      isNotEdge() {
        let browser = this.sharedState.browser
        if (browser == 'ie' || browser == 'edge') {
          return false
        } else {
          return true
        }
      }
    },
    methods: {
        onChange (eve) {
          this.$store.commit("setYear", this.localYear)
        },
    }
}
</script>

<style scoped lang="scss">
$track-width: 600px;
$track-height: 15px;
$track-border: medium none;
$track-border-radius: 8px;
$thumb-size: 46px;
$thumb-color: #13A695;
$thumb-border: 2px solid #FFF;

.slider-area {

  input[type=range] {
    /*removes default webkit styles*/
    -webkit-appearance: none;

    /*required for proper track sizing in FF*/
    width: $track-width;
    border-radius: $track-border-radius;
  }
  input[type=range]::-webkit-slider-runnable-track {
    width: $track-width;
    height: $track-height;
    /* background: $track-background; */
    border: $track-border;
    border-radius: $track-border-radius;
  }
  input[type=range]::-webkit-slider-thumb {
    -webkit-appearance: none;
    border-radius: 50%;
    border: $thumb-border;
    height: $thumb-size;
    width: $thumb-size;
    background: $thumb-color;
    margin-top: -$track-height;
  }
  input[type=range]:focus {
    outline: none;
  }
  input[type=range]::-moz-range-track {
    width: $track-width;
    height: $track-height;
    /* background: $track-background; */
    border: $track-border;
    border-radius: $track-border-radius;
  }
  input[type=range]::-moz-range-thumb {
    border-radius: 50%;
    border: $thumb-border;
    height: $thumb-size;
    width: $thumb-size;
    background: $thumb-color;
  }
  /*hide the outline behind the border*/
  input[type=range]::-moz-focus-outer {
    border: 0;
  }

  input[type=range]::-ms-track {
    width: $track-width;
    height: $track-height;

    /*remove bg colour from the track, we'll use ms-fill-lower and ms-fill-upper instead */
    background: transparent;

    /*leave room for the larger thumb to overflow with a transparent border */
    border-color: transparent;
    border-width: 20px 0;

    /*remove default tick marks*/
    color: transparent;
  }
  input[type=range]::-ms-fill-lower {
    background: #777;
    border-radius: 10px;
  }
  input[type=range]::-ms-fill-upper {
    /* background: $track-background; */
    border-radius: 10px;
  }
  input[type=range]::-ms-thumb {
    border: $thumb-border;
    height: $thumb-size;
    width: $thumb-size;
    border-radius: 50%;
    background: $thumb-color;
  }
}

@media all and (-ms-high-contrast:none) {
  .slider-area .year-label{
    padding-top: 85px;
  }
  .year-label{
    margin-top: 30px;
  }
}

.slider-area{
  width: 800px;

  .slider-inner{
    left: 50%;
    margin-left: -295px;
    position: absolute;
  }
  .year-label{
    // display: block;
    display: flex;
    overflow: hidden;
    padding: 50px 0px 0px 12%;
    flex-direction: row;
    li{
      display: inline-block;
      text-align: center;
      // width: calc(16% - 4px);
      width: 100%;
    }
  }
  .slider{
    cursor: pointer;
  }


  input[type=range] {
    -webkit-appearance: none;
    margin: 0;
    // width: 100%;
    // height: 50px;
  }
  // input[type=range]:focus {
  //   outline: none;
  // }

  // /* WebKit・Blink向け 溝のスタイル */
  // input[type=range]::-webkit-slider-runnable-track {
  //   width: 100%;
  //   height: 12px;
  //   cursor: pointer;
  //   animate: 0.2s;
  //   box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  //   background: #cccccc;
  //   border-radius: 1.3px;
  //   border: 1px solid #010101;
  // }
  // /* WebKit・Blink向け つまみのスタイル */
  // input[type=range]::-webkit-slider-thumb {
  //   box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  //   border: 1px solid #000000;
  //   height: 36px;
  //   width: 36px;
  //   border-radius: 50%;
  //   background: #ffffff;
  //   cursor: pointer;
  //   -webkit-appearance: none;
  //   /* 以下は つまみの縦位置調整 */
  //   margin-top: -14px;  /* (つまみの高さ - トラックの高さ) / 2 。つまみの高さは border を含む */
  // }

  /* 何故か上の margin-top 指定が Edge に効いてしまうので、Edge向けに設定をリセット */
  @supports (-ms-ime-align: auto) {
    input[type=range]::-webkit-slider-thumb {
      margin-top: -3px !important;
    }
  }

  // /* WebKit・Blink向け focus時のスタイル */
  // input[type=range]:focus::-webkit-slider-runnable-track {
  //   background: #999999;
  // }

  /* Firefox向け 溝のスタイル */
  // input[type=range]::-moz-range-track {
  //   width: 100%;
  //   height: 12px;
  //   cursor: pointer;
  //   animate: 0.2s;
  //   box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  //   background: #cccccc;
  //   border-radius: 1.3px;
  //   border: 0.2px solid #010101;
  // }
  // /* Firefox向け つまみのスタイル */
  // input[type=range]::-moz-range-thumb {
  //   box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  //   border: 1px solid #000000;
  //   height: 36px;
  //   width: 36px;
  //   border-radius: 50%;
  //   background: #ffffff;
  //   cursor: pointer;
  // }

  /* Edge・IE向け 溝のスタイル */
  input[type=range]::-ms-track {
    // padding-top: 20px;
    margin-top: -30px;
    padding-top: 27px;
    padding-bottom: 29px;
    width: $track-width;
    height: $track-height;
    // height: 50px;
    cursor: pointer;
    animate: 0.2s;
    background: transparent;
    border-color: transparent;
    border-width: 20px 0;
    color: transparent;
  }

  /* Edge・IE向け 溝の色（つまみより左側） */
  // input[type=range]::-ms-fill-lower {
  //   background: #cccccc;
  //   border: 0.2px solid #000000;
  //   border-radius: 10px;
  //   box-shadow: 1px 1px 1px #000000, 0px 0px 1px #000000;
  // }
  input[type=range]::-ms-fill-lower {
    background: #f5f5f5;
    border-color: transparent;
    border-radius: 10px;
    // box-shadow: 1px 1px 1px #000000, 0px 0px 1px #000000;
  }
  /* Edge・IE向け 溝の色（つまみより右側） */
  input[type=range]::-ms-fill-upper {
    background: #f5f5f5;
    // border: 0.2px solid #000000;
    border-radius: 10px;
    // box-shadow: 1px 1px 1px #000000, 0px 0px 1px #000000;
  }
  /* Edge・IE向け つまみのスタイル */
  input[type=range]::-ms-thumb {
    // box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    // border: 1px solid #000000;
    border: $thumb-border;
    height: $thumb-size;
    width: $thumb-size;
    border-radius: 50%;
    background: $thumb-color;
    cursor: pointer;
  }
  /* Edge・IE向け focus時の色（つまみより左側） */
  input[type=range]:focus::-ms-fill-lower {
    // background: 'red';
  }
  /* Edge・IE向け focus時の色（つまみより右側） */
  input[type=range]:focus::-ms-fill-upper {
    // background: #999999;
  }

  /* Edge・IE向け ポップアップを非表示に */
  input[type=range]::-ms-tooltip {
    display: none;
  }
}

</style>


